import Divider from "@components/common/Divider";
import { JSON_SCHEMAS } from "@components/utils/constants";
import { ILocationResponse } from "@customTypes/modelResponses";
import styledParser from "@libs/parser/styled-parser";
import JsonLdSchema from "@libs/schema/JsonLdSchema";

interface ILocationPageTopSection {
  data: ILocationResponse;
}

const LocationPageTopSection = ({
  data,
}: ILocationPageTopSection): JSX.Element => {
  return (
    <>
      <JsonLdSchema
        data={{
          breadcrumbObjects: undefined,
          schema: undefined,
          content: data,
        }}
        type={JSON_SCHEMAS.ATTRACTION}
      />
      <div className="relative flex w-full justify-between">
        <div className="mx-5 desktop:mx-0">
          <div className="w-[100%]">
            <p className="text-p text-darkgray">
              {styledParser(data.Overview)}
            </p>
          </div>
        </div>
      </div>
      <Divider variant="short" />
    </>
  );
};

export default LocationPageTopSection;
